
import React, { useEffect, useState, useRef, } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    useCRUDController,
    Textarea,
    Card,
    Modal,
    Button,
    Typography,
    message,
    ProTableOt,
    useProTableOt,
    setParamsFilter,
    ExpandableText,
    DatePicker,
    Checkbox,
    Select
} from '../../ui/ot'
import { Label } from "../../ui/label"
import { useTranslation } from "react-i18next";
import { Trash2, Plus, Check, TriangleAlert, Info, Clock, X } from "lucide-react";
import dayjs from 'dayjs';

const OpeningHoursManagementForm = ({
    propsForm,
    field,
    onFormFinish = () => { },
    keyPrefix = "library.backstage.opening_hours_management",
    propsReloadCount,
    withdrawnOptions = []

}) => {

    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        let bibs_list_items_data = (values?.bibs_list_items_data || []).map((bibValue) => {
            return {
                ...bibValue,
                biblionumber: bibValue?.bib_biblionumber
            }
        })
        let temp = {
            ...values,
            bibs_list_items_data,
        }
        temp = setParamsFilter({ ...temp })

        onFormFinish({
            ...temp
        });

    };
    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        formValues = form.getFieldsValue();
    };


    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };

    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                axiosMode={axiosMode}
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={form.setFieldValue}
                                setCount={setCount}
                                keyPrefix={keyPrefix}
                                propsForm={form}
                                propsReloadCount={propsReloadCount}
                                withdrawnOptions={withdrawnOptions}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    propsForm,
    field,
    keyPrefix = "library.backstage.opening_hours_management",
    propsReloadCount,
    withdrawnOptions = [],
    getAnyFormValue
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef();
    const columns = [
        {
            title: t(`cover`),
            dataIndex: 'bibitem_isbn',
            key: 'bibitem_isbn',
            width: 50,

            render: (text, record, index) => {
                return (
                    <Row justify="center">
                        <Col>
                            <img src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=" +
                                record?.bibitem_isbn} alt={record?.bib_title} className="h-24 w-16 object-cover" />
                        </Col>
                    </Row>

                )

            }
        },
        {
            title: t(`title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: 250,
            render: (text, record, index) => {
                return (<ExpandableText
                    text={`${record?.bib_title || ""}${record?.bib_subtitle || ""}${record?.bib_author || ""}`}

                    maxLines={3}>
                </ExpandableText>)
            }
        },
        {
            title: t(`author`),
            dataIndex: 'bib_author',
            key: 'bib_author',
        },
        {
            title: t(`publication_info`),
            dataIndex: 'bibitem_publishercode',
            key: 'bibitem_publishercode',
        },
        {
            title: t(`publication_date`),
            dataIndex: 'bib_copyrightdate',
            key: 'bib_copyrightdate',
        },
        {
            title: t(`actions`),
            dataIndex: 'operation',
            key: 'operation',
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                return (<Button
                    variant="ghost"
                    onClick={() => {
                        let oldData = propsForm.getFieldValue("bibs_list_items_data")
                        let data = oldData.filter((ele, ind) => ind !== index)
                        propsForm.setFieldValue("bibs_list_items_data", data)
                        reload()
                    }}
                >
                    <Trash2 className="h-4 w-4" />
                    {t('delete')}
                </Button>)
            }
        },


    ];

    const reload = () => {
        actionRef.current.reloadAndRest()
    }
    const addTimeSlot = (dayIndex) => {
        const updatedSchedule = [...getAnyFormValue('schedule')]
        updatedSchedule[dayIndex].timeSlots.push({
            startTime: "08:00",
            endTime: "10:00",
            isOpen: true,
        })
        // setSchedule(updatedSchedule)
    }

    const removeTimeSlot = (dayIndex, slotIndex) => {
        const updatedSchedule = [...getAnyFormValue('schedule')]
        updatedSchedule[dayIndex].timeSlots.splice(slotIndex, 1)
        // setSchedule(updatedSchedule)
    }

    const updateTimeSlot = (dayIndex, slotIndex, field, value) => {
        const updatedSchedule = [...getAnyFormValue('schedule')]
        updatedSchedule[dayIndex].timeSlots[slotIndex] = {
            ...updatedSchedule[dayIndex].timeSlots[slotIndex],
            [field]: value,
        }
        // setSchedule(updatedSchedule)
    }
    useEffect(() => {
        if (!!propsReloadCount) {
            reload()
        }

    }, [propsReloadCount])
    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={24}>

                    <Row>
                        <Form.Item
                            hidden={true}
                            {...field}
                            name={[field?.name ?? '', 'list_id']}
                            fieldKey={[field?.fieldKey ?? '', 'list_id']}
                        >
                            <div></div>
                        </Form.Item>
                        <Form.Item
                            hidden={true}
                            {...field}
                            name={[field?.name ?? '', 'task_id']}
                            fieldKey={[field?.fieldKey ?? '', 'task_id']}
                            labelCol={24}
                            wrapperCol={24}
                        >
                            <div></div>
                        </Form.Item>
                    </Row>
                </Col>
                {/* <Col span={24}>
                    <Form.List
                        {...field}
                        fieldKey={[field?.fieldKey ?? '', 'schedule_data']}
                        name={[field?.name ?? '', 'schedule_data']}
                    >
                        {(fields, { add, remove }) => <Row gutter={[8, 8]}>
                            {
                                fields?.map((field, dayIndex) => {
                                    return (
                                        <div key={dayIndex} className="bg-gray-50 rounded-lg p-4">
                                            <div className="font-medium mb-2">{field.name}</div>
                                            <Form.List
                                                {...field}
                                                fieldKey={[field?.fieldKey ?? '', 'timeSlots']}
                                                name={[field?.name ?? '', 'timeSlots']}
                                            >
                                                {(fields, { add, remove }) => <Row gutter={[8, 8]}>
                                                    {
                                                        fields?.map((field, dayIndex) => {
                                                            return (
                                                                <div
                                                                    // key={slotIndex} 

                                                                    className="flex items-center gap-2 mb-2">
                                                                    <div className="flex items-center gap-2">
                                                                        <Form.Item
                                                                            {...field}
                                                                            name={[field?.name ?? '', 'task_id']}
                                                                            fieldKey={[field?.fieldKey ?? '', 'task_id']}
                                                                        >
                                                                            <Input type="time" ></Input>
                                                                        </Form.Item>
                                                                    </div>
                                                                    <span className="text-gray-600">至</span>
                                                                    <div className="flex items-center gap-2">
                                                                        <Form.Item
                                                                            labelCol={18}
                                                                            wrapperCol={6}
                                                                            name={[field.name, 'tag']}
                                                                        >
                                                                            <Input type="time" ></Input>
                                                                        </Form.Item>
                                                                    </div>
                                                                    <div className="flex items-center gap-2 ml-2">
                                                                            <Checkbox
                                                                                id={`open-${dayIndex}-${slotIndex}`}
                                                                                checked={slot.isOpen}
                                                                                onCheckedChange={(checked) => updateTimeSlot(dayIndex, slotIndex, "isOpen", Boolean(checked))}
                                                                            />
                                                                            <label htmlFor={`open-${dayIndex}-${slotIndex}`} className="text-sm text-gray-600">
                                                                                開放
                                                                            </label>
                                                                        </div>

                                                                        <button
                                                                            onClick={() => removeTimeSlot(dayIndex, slotIndex)}
                                                                            className="ml-auto text-gray-400 hover:text-gray-600"
                                                                        >
                                                                            <X className="w-4 h-4" />
                                                                        </button>
                                                                </div>
                                                            )
                                                        })
                                                    }

                                                </Row>}
                                            </Form.List>


                                            <Button
                                                variant="outline"
                                                size="sm"
                                                className="mt-2 text-xs bg-indigo-50 text-indigo-600 border-indigo-100 hover:bg-indigo-100"
                                                onClick={() => addTimeSlot(dayIndex)}
                                            >
                                                <Plus className="w-3 h-3 mr-1" />
                                                新增時段
                                            </Button>
                                        </div>
                                    )
                                })
                            }

                        </Row>}
                    </Form.List>
                </Col> */}
            </Row>
        </>
    );
};
const AddBibModal = ({
    reload = () => { },
    field,
    propsForm,
    propsOpen = null,
    propsLoading = null,
    openButtonText = "詳細資訊",
    defaultSelectkeys = [],
    defaultSelectInfos = [],
    propsSetOpen = () => { },
    propsHandleOk = () => { },
    t,
}) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectRow, setSelectRow] = useState(null)
    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
        reload()
    };

    const handleOk = () => {
        setLoading(true);
        propsHandleOk(selectRow)
        closeModal();

    };

    return (
        <div>
            <Button
                onClick={showModal}
            >
                {t('add_detail')}
            </Button>

            <Modal
                title={`${openButtonText}`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                // onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                width={1000}
                contentStyle={{
                    padding: 16,
                }}
                okText={'關閉'}
            >
                <Row>
                    <Col span={24}>
                        <BibTable
                            defaultSelectkeys={defaultSelectkeys}
                            defaultSelectInfos={defaultSelectInfos}
                            onSelectChange={(value) => {
                                if (!!propsForm) {
                                    propsForm.setFieldValue("bibs_list_items_data", value)
                                }
                            }}
                        />
                    </Col>
                </Row>
            </Modal>

        </div>
    );
}
const BibTable = ({
    rowKey = "bib_biblionumber",
    keyPrefix = "library.backstage.opening_hours_management",
    showAllColumns = true,
    propsShowColumns,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }//selectInfo
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [tableSearchParams, setTableSearchParams] = useState({
    });
    const [search, setSearch] = useState({
        datecreated_start: dayjs().subtract(1, 'year').startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        datecreated_end: dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    })
    const columns = [
        {
            title: t(`cover`),
            dataIndex: 'bibitem_isbn',
            key: 'bibitem_isbn',
            width: 50,

            render: (text, record, index) => {
                return (
                    <Row justify="center">
                        <Col>
                            <img src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=" +
                                record?.bibitem_isbn} alt={record?.bib_title} className="h-24 w-16 object-cover" />
                        </Col>
                    </Row>

                )

            }
        },
        {
            title: t(`title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: 250,
            render: (text, record, index) => {
                return (<ExpandableText
                    text={`${record?.bib_title || ""}${record?.bib_subtitle || ""}${record?.bib_author || ""}`}

                    maxLines={3}>
                </ExpandableText>)

            }
        },
        {
            title: t(`author`),
            dataIndex: 'bib_author',
            key: 'bib_author',
        },
        {
            title: t(`publication_info`),
            dataIndex: 'bibitem_publishercode',
            key: 'bibitem_publishercode',
        },
        {
            title: t(`publication_date`),
            dataIndex: 'bib_copyrightdate',
            key: 'bib_copyrightdate',
        },


    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : [])
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const onFinish = ({ axiosMode, status, values }) => {

    };
    const onBefore = ({ axiosMode, status, values }) => {

    };

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });

    const BibController = useCRUDController({
        apiRoute: "/koha/bib",
        onFinish,
        onBefore
    })

    useEffect(() => {
        checkAll();
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [tableSearchParams])
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <ProTableOt
                searchParams={{
                    ...tableSearchParams,
                }}
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return [
                        <Col span={24}>
                            <Row gutter={[4, 4]} align={"middle"}>
                                <Col>
                                    <Typography.P>
                                        {/* {t(`${i18nPrefix}.import_bibliography_date`)}: */}
                                    </Typography.P>
                                </Col>
                                <Col>
                                    <DatePicker.Time
                                        granularity={"day"}
                                        placeholder={t(`time_start`)}
                                        format={"YYYY-MM-DD"}
                                        value={search?.datecreated_start ? search?.datecreated_start : undefined}
                                        onChange={(e) => {
                                            setSearch((pre) => {
                                                if (dayjs(e.target.value).isBefore(dayjs(pre?.datecreated_end, "YYYY-MM-DD"))) {
                                                    return {
                                                        ...pre,
                                                        datecreated_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        datecreated_start: pre?.datecreated_end,
                                                        datecreated_end: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <Typography.Title level={4}>
                                        ~
                                    </Typography.Title>
                                </Col>
                                <Col>
                                    <DatePicker.Time
                                        granularity={"day"}
                                        placeholder={t(`${"time_end"}`)}
                                        format={"YYYY-MM-DD"}
                                        value={search?.datecreated_end ? search?.datecreated_end : undefined}
                                        onChange={(e) => {
                                            setSearch((pre) => {
                                                if ((dayjs(e.target.value)).isBefore(pre?.datecreated_start)) {
                                                    return {
                                                        ...pre,
                                                        datecreated_start: e.target.value,
                                                        datecreated_end: pre?.datecreated_start,
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        datecreated_end: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                {(search.time_start || search.time_end) &&
                                    <Col>
                                        <Button
                                            type={"icon"}
                                            onClick={() => {
                                                setSearch((pre) => {
                                                    return {
                                                        datecreated_start: undefined,
                                                        datecreated_end: undefined
                                                    }
                                                })
                                            }}>
                                            X
                                        </Button>
                                    </Col>
                                }
                            </Row>
                        </Col>
                    ]
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    let newTableSearchParams = { ...tableSearchParams }

                    newParams = {
                        ...newParams,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        // custom_filter_value: params.keyword ?? "",
                        keyword: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        "field": !!params.keyword ? "keyword" : "",
                        ...search
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return BibController.getData(newParams);
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }
                propsPatch={false}
                propsDelete={false}
                propsPost={false}
                propsWidth={2400}
                scroll={{
                    x: "100%",
                }}
            // extraActionRender={(record) => {
            // }}
            />
        </Col>
    </Row>)

}




export default OpeningHoursManagementForm;
